<template>
  <div class="kpt-api-client-management">
    <header>
      <h6><strong>API Clients</strong></h6>
      <b-button :type="!addApiClientOpen ? 'is-primary' : 'is-light'" size="is-small" :icon-left="addApiClientOpen ? 'minus' : 'plus'" @click="addApiClientOpen = !addApiClientOpen">
        <span v-if="!addApiClientOpen">Add</span>
        <span v-else>Cancel</span>
      </b-button>
    </header>
    <b-collapse :open.sync="addApiClientOpen">
      <div class="kpt-apiclient-add-panel">
        <b-message type="is-info">
          Once you add a Client ID and secret, you will not be able to view the secret again. Kymeta does not have access to user secrets. Please ensure you have it saved elsewhere.
        </b-message>
        <label class="label">
          <b-input type="text" v-model="newApiClient.clientId" placeholder="Client ID" />
        </label>
        <label class="label">
          <b-input type="text" v-model="newApiClient.secret" placeholder="Secret" maxlength="255" :has-counter="false" />
        </label>
        <b-button type="is-primary" @click="addNewApiClient" :disabled="apiClientAdding" size="is-small" :loading="apiClientAdding">Add API Client</b-button>
      </div>
    </b-collapse>
    <div class="kpt-api-clients-list">
      <table class="table is-fullwidth is-narrow" v-if="apiClients.length">
        <tbody>
          <tr v-for="(cl, idx) in apiClients" :key="idx">
            <td>{{cl.clientId}}</td>
            <td class="table-actions">
              <font-awesome-icon :icon="['far', 'trash-alt']" class="has-cursor-pointer" @click="deleteApiClient(cl.clientId)" v-if="apiClientDeleting != cl.clientId" />
                <font-awesome-icon :icon="['far', 'circle-notch']" spin v-if="apiClientDeleting == cl.clientId" />
            </td>
          </tr>
        </tbody>
      </table>
      <p v-else>There are no API clients to show here.</p>
      <b-loading :active="apiClientsLoading" :is-full-page="false"></b-loading>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addApiClientOpen: false,
      newApiClient: {
        clientId: null,
        secret: null
      },
    }
  },
  computed: {
    apiClients() {
      return this.$store.state.user.apiclients.apiClients;
    },
    apiClientsLoading() {
      return this.$store.state.user.apiclients.apiClientsLoading;
    },
    apiClientAdding() {
      return this.$store.state.user.apiclients.apiClientAdding;
    },
    apiClientDeleting() {
      return this.$store.state.user.apiclients.apiClientDeleting;
    }
  },
  mounted() {
    this.$store.dispatch('fetchApiClients');
  },
  methods: {
    async addNewApiClient() {
      const result = await this.$store.dispatch('addApiClient', this.newApiClient);
      if (result) {
        this.newApiClient = {
          clientId: null,
          secret: null
        }
        this.addApiClientOpen = false;
      }
      // KyAnalytics client plugin, event tracker
      this.$kya.event('system', 'addApiClient', 'User added new ApiClient', { payload: this.newApiClient });
    },
    async deleteApiClient(clientId) {
      // KyAnalytics client plugin, event tracker
      this.$kya.event('system', 'deleteApiClient', 'User deleted ApiClient', { payload: clientId });
      await this.$store.dispatch('deleteApiClient', clientId);
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../styles/colors';
.kpt-api-client-management {
  header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    align-items: center;
    border-bottom: 1px solid $grey-lighter;
    padding-bottom: 12px;
    margin-bottom: 12px;
  }

  .kpt-apiclient-add-panel {
    border: 1px solid $grey-lighter;
    padding: 8px;
    margin-bottom: 12px;
  }

  .kpt-api-clients-list {
    position: relative;
    margin-bottom: 2rem;

    .table {
      .table-actions {
        width: 50px;
        text-align: right;
      }
    }

    .loading-overlay {
      min-height: 50px;
    }
  }
}
</style>
